// A datalog gone from TUNE's cloud goes from this browser too: the Analyser's reading of it, and the circuit it found.
import { dropCachedLog } from '../analyzer/data/logCache';
import { clearCachedDatalogCircuit } from '../analyzer/site/lib/datalogCircuitCache';

export async function forgetDatalog(id: string): Promise<void> {
  clearCachedDatalogCircuit(id);
  await dropCachedLog(id);
}
